import React from "react"
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../app/helpers/helperCatalogs";

const NewRelationGenericDescription = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation, comboData }) => {

  const { t } = useTranslation();

  const customTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    
    colors: {
      ...theme.colors,
      primary25: "lightblue", 
      primary: "green", 
      
    },
  });

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}</label>
      <div className="control">
        <Select
          theme={customTheme}
          styles={{
            control: (provided) => ({
              ...provided,
              borderColor: errors?.[field] ? "#dc3545" : provided.borderColor,
              boxShadow: errors?.[field] ? "0 0 0 1px #dc3545" : provided.boxShadow
            })
          }}
          
          myFontSize="14px"

          onChange={(event) => handleChange(event, field)}
          
          className={`basic-single form-control txt-view ${errors?.[field] && "border border-danger"}`}
          classNamePrefix="select"
          name={field}
          inputId={field}

          value={(field && values?.[field]) || null}
          options={comboData || []}
          getOptionLabel={(option) => catalogTableLabel(option)}
          getOptionValue={(option) => `${option}`}
          isClearable={true}
          isSearchable={true}
          placeholder={placeholderVal ? t("combo.placeholder") : null}
        />
        {errors?.[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewRelationGenericDescription;